import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  CircularProgress,
  FormHelperText,
} from "@mui/material";

const EditCategoryDialog = ({ open, onClose, onSubmit, initialData = {} }) => {
  const [name_ar, setNameAr] = useState("");
  const [name_en, setNameEn] = useState("");
  const [desc_ar, setDescAr] = useState("");
  const [desc_en, setDescEn] = useState("");

  const [image, setImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setNameAr(initialData.name_ar || "");
      setNameEn(initialData.name_en || "");
      setDescAr(initialData.desc_ar || "");
      setDescEn(initialData.desc_en || "");
      setImage(null);
      setError(null);
    } else {
      setSubmitting(false);
    }
  }, [open, initialData]);

  const handleSave = async () => {
    setError(null);
    if (!name_ar && !name_en) {
      setError("Please provide name_ar or name_en");
      return;
    }
    const formData = new FormData();
    // include id for update
    if (initialData.id) formData.append("id", String(initialData.id));
    formData.append("name_ar", name_ar);
    formData.append("name_en", name_en);
    formData.append("desc_ar", desc_ar);
    formData.append("desc_en", desc_en);
    // keep existing status; status changes are handled only by the toggle action outside this dialog
    const currentStatus = initialData.status === 1 || initialData.status === "1" || initialData.status === true ? "1" : "0";
    formData.append("status", currentStatus);
    if (image) formData.append("image", image);
    // keep category_id if present
    if (initialData.category_id !== undefined && initialData.category_id !== null) {
      formData.append("category_id", String(initialData.category_id));
    }

    try {
      setSubmitting(true);
      const res = await onSubmit(formData);
      return res;
    } catch (err) {
      setError(err?.message || "Error updating category");
      throw err;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !submitting && onClose && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>تعديل الفئة</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "grid", gap: 2, mt: 1 }}>
          <TextField label="الاسم (عربي)" value={name_ar} onChange={(e) => setNameAr(e.target.value)} fullWidth />
          <TextField label="الاسم (EN)" value={name_en} onChange={(e) => setNameEn(e.target.value)} fullWidth />
          <TextField label="الوصف (عربي)" value={desc_ar} onChange={(e) => setDescAr(e.target.value)} fullWidth multiline minRows={2} />
          <TextField label="الوصف (EN)" value={desc_en} onChange={(e) => setDescEn(e.target.value)} fullWidth multiline minRows={2} />
          <Box>
            <input id="edit-cat-image" type="file" accept="image/*" onChange={(e) => setImage(e.target.files?.[0] || null)} />
            <FormHelperText>اختياري - رفع صورة جديدة سيستبدل القديمة</FormHelperText>
          </Box>
          {error ? <Box sx={{ color: "error.main", fontSize: 13 }}>{error}</Box> : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => !submitting && onClose && onClose()}>إلغاء</Button>
        <Button variant="contained" onClick={handleSave} disabled={submitting}>
          {submitting ? <CircularProgress size={20} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCategoryDialog;
